import CreatePage from '@/components/create-page';

export default function Create() {
  return <CreatePage />;
}
